import { useState } from 'react';
import axios from 'axios';
import { notify } from '../../common/functions/react-toastify.function';
import { useLocation, useNavigate } from 'react-router-dom';
import { consumePostLoginRedirect } from './protected_Routes_component';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import { Box } from '@mui/material';
import RovInsights from '../../Assets/Logos/new_oko_logo.svg';
import JazzLogo from '../../Assets/Logos/FiberLiveLogo.png';
import loginBackground from '../../Assets/AlertIcon/loginBackground.svg';
import { LoginForm } from './LoginForm';

export const LoginContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const navigate = useNavigate();
  const location = useLocation();
  const environment = process.env.REACT_APP_ENVIRONMENT;

  const handleLoginSubmit = async (loginData) => {
    setIsLoading(true);
    showBackdrop();

    if (loginData.email && loginData.password) {
      try {
        const response = await axios.post(`${apiUrl}/auth/login`, loginData, {
          withCredentials: true,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
          },
        });

        sessionStorage.setItem('logInState', JSON.stringify(response.data.response.name));
        localStorage.setItem('logInState', JSON.stringify(response.data.response.name));
        sessionStorage.setItem('logInUserEmail', JSON.stringify(response.data.response.email));
        sessionStorage.setItem('tenantId', response.data.response.tenant_id);
        sessionStorage.setItem('tenantName', JSON.stringify(response.data.response.tenant_name));
        localStorage.setItem('permissions', JSON.stringify(response.data.response.permissions));

        const accessToken = sessionStorage.getItem('logInState');
        if (accessToken) {
          notify('success', `Login successful as ${response.data.response.name}`);
          const redirect = consumePostLoginRedirect(location.search);
          navigate(redirect || '/rov', { replace: true });
          hideBackdrop();
        } else {
          console.error('Token is not set in cookies.');
          hideBackdrop();
          notify('error', 'Login failed: Token not found.');
        }
      } catch (err) {
        notify(
          'error',
          err?.response?.data?.message
            ? err?.response?.data?.message
            : err.message
              ? err.message
              : 'Something went wrong'
        );
        hideBackdrop();
      }
    } else {
      notify('error', 'Please add email and password');
      hideBackdrop();
    }

    setIsLoading(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        position: 'relative',
        overflow: 'hidden',
        background: '#EEF1FA',
      }}
    >
      <Box
        component="img"
        src={loginBackground}
        alt="background"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <Box
        sx={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '16px',
          boxShadow: '4px 4px 20px 2px rgba(12.50, 125.67, 255, 0.20)',
          width: '100%',
          maxWidth: '450px',
          textAlign: 'center',
          zIndex: 1,
        }}
      >
        <Box sx={{ marginBottom: '30px' }}>
          <img
            src={environment === 'production' ? JazzLogo : RovInsights}
            alt={environment === 'production' ? 'JAZZ' : 'OKO Insights'}
            style={{ maxWidth: '150px' }}
          />
        </Box>
        <LoginForm onSubmit={handleLoginSubmit} isLoading={isLoading} />
      </Box>
    </Box>
  );
};
